// Breadcrumb toggle functionality - execute immediately
(function() {  
  function initBreadcrumbs() {    
    const buttons = document.querySelectorAll('.breadcrumbs__toggle');
    
    if (buttons.length === 0) {
      return;
    }
    
    buttons.forEach((btn, index) => {
      
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const targetSelector = this.dataset.target;
        
        // Find in closest nav
        const nav = this.closest('nav');
        const target = nav ? nav.querySelector('.' + targetSelector) : null;
                
        if (target) {
          target.classList.add('is-open');
          this.style.display = 'none';
        }
      });
    });
  }
  
  // Try immediate
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBreadcrumbs);
  } else {
    initBreadcrumbs();
  }
  
  // Also try MutationObserver in case elements are added dynamically
  setTimeout(initBreadcrumbs, 100);
})();
